module.exports = __webpack_public_path__ + "img/pin-wali-murid.bf6d7323.png";